import script from './component-lib.esm3.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Paper', _vm._g(_vm._b({
    staticClass: "v-toolbar",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "component": "header"
    }
  }, 'Paper', Object.assign({}, _vm.$props, _vm.$attrs), false), _vm.$listeners), [_c('div', {
    staticClass: "v-toolbar__content"
  }, [_vm._t("default", null, {
    "color": _vm.textColor
  })], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-ba18c12a_0", {
    source: ".v-toolbar.v-toolbar[data-v-ba18c12a]{border-radius:0}.v-toolbar.v-toolbar--rounded[data-v-ba18c12a]{border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min))}.v-toolbar[data-v-ba18c12a]{contain:layout;display:block;flex:1 1 auto;max-width:100%;position:relative}.v-toolbar--flat[data-v-ba18c12a]{box-shadow:none}.v-toolbar--dense .v-toolbar__content[data-v-ba18c12a]{height:3rem}.v-toolbar__content[data-v-ba18c12a]{color:var(--c-text-color);align-items:center;display:flex;position:relative;z-index:0;padding:.25rem 1rem;height:4rem}.v-toolbar__content[data-v-ba18c12a]>.v-button:first-child+.v-toolbar__title,.v-toolbar__content[data-v-ba18c12a]>.v-icon-btn:first-child+.v-toolbar__title{padding-left:1.25rem}.v-toolbar__content[data-v-ba18c12a]>.v-button:first-child,.v-toolbar__content[data-v-ba18c12a]>.v-icon-btn:first-child{margin-left:-.5rem}.v-toolbar__content[data-v-ba18c12a]>.v-button:last-child,.v-toolbar__content[data-v-ba18c12a]>.v-icon-btn:last-child{margin-right:-.5rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-ba18c12a";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };